export enum AppealAddressTypeEnum {
    Coporation = '1',
    Individual = '2'
}
